import React from "react";

export default function () {
  return (
    <div id="admission" className="relative bg-white pt-8">
      <div
        className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
        style={{ height: "80px", transform: "translateZ(0)" }}
      >
        <svg
          className="absolute bottom-0 overflow-hidden"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon
            className="text-white fill-current"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
      <div className="container mx-auto px-4">
        <div className="flex relative justify-center">
          <h2 className="text-6xl text-center font-semibold text-gray-800">
            Admission
          </h2>
          <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 transform w-80 h-3 bg-red-500"></div>
        </div>
        <div
          style={{ boxShadow: "0 0 1.5rem rgba(0,0,0, 0.08)" }}
          className="flex flex-col lg:flex-row items-center justify-between p-8 shadow-lg rounded-xl mt-16"
        >
          <div className="w-full pb-6 lg:pb-0 lg:w-1/2 text-gray-800">
            <div className="w-full lg:max-w-lg mx-auto">
              <h2 className="font-bold mb-3 text-2xl">Eligibility Criteria</h2>
              <p>
                <span className="font-semibold">Qualification:</span> 12th
                passed / Pursuing Graduation / Graduates
              </p>
              <p>
                <span className="font-semibold">Age:</span> 18 to 25 years
              </p>
              <p className="my-4 font-semibold text-green-500">
                ** Special course for 10th passed
              </p>
              <p className="">
                Anyone who wants to change the way people looks at you, should
                join the program at{" "}
                <span className="font-semibold">
                  <span className="text-red-500">Redd</span>Wings
                </span>
              </p>
              <p>
                Fill up the details and get FREE career counselling from the
                experts:-
              </p>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <form className="w-full lg:max-w-lg mx-auto">
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full mb-6 md:mb-0 md:w-1/2 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="adminssion-grid-first-name"
                  >
                    First Name
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="adminssion-grid-first-name"
                    type="text"
                    placeholder="John"
                  />
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="adminssion-grid-last-name"
                  >
                    Last Name
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="adminssion-grid-last-name"
                    type="text"
                    placeholder="Doe"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="adminssion-grid-qualification"
                  >
                    Qualification
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="adminssion-grid-qualification"
                    type="text"
                    placeholder="B. Sc"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="adminssion-grid-contact"
                  >
                    Contact No.
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="adminssion-grid-contact"
                    type="number"
                    placeholder="1111111111"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="adminssion-grid-dob"
                  >
                    Date of birth
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="adminssion-grid-dob"
                    type="date"
                    placeholder="Albuquerque"
                  />
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="adminssion-grid-gender"
                  >
                    gender
                  </label>
                  <div className="relative">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="adminssion-grid-gender"
                    >
                      <option>Male</option>
                      <option>Female</option>
                      <option>Other</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <button
                className="w-full mt-6 bg-green-600 hover:bg-green-700 text-white text-sm py-2 px-4 font-semibold rounded focus:outline-none focus:shadow-outline h-10"
                type="button"
              >
                Get Free Counselling
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
